/* exported bocAmchart4 */
/* global am4core */

/**
 * Container object for Bank of Canada functions for setting up AmCharts
 */
var bocAmchart4 = {};
am4core.options.autoSetClassName = true;
am4core.options.deferredDelay = 0;
am4core.options.minPolylineStep = 3;
am4core.options.queue = true;


/**
 * Version file, listing the features implemented, latest at the end of the array (under features),
 * make sure to separate the tasks to avoid merge conflicts
 * The entries could be deleted after they are code released on prod (not via uploads)
 * @type {{svn: string, features: string[]}}
 */
bocAmchart4.version = {
    "svn": "$Revision: 34414 $".match(/\$Revision:\s*(\d+)\s*\$/)[1],
    "date": "$Date: 2025-03-12 11:24:14 -0400 (Wed, 12 Mar 2025) $".match(/\$Date:\s*(.+)\s*\$/)[1],
    "features": {}
};

bocAmchart4.version.features['DEV-9004-Add-midcolor-labels-for-heatmap-legend'] = [
    'Added a new "heatmapdisplaymidlabels" parameter to display midColorValues as labels on a heatmap legend',
    'Fixed positioning of all labels',
    'Fixed incorrect max value label being displayed',
    'Added a link to heatmaps documentation on WCD',
    'Fixed incorrect calculation of min/max values from the dataset',
    "Updated so separateOverflow works when it's set to false"
];

bocAmchart4.version.features['DEV-7757-Convert the titles and subtitles of the charts to use HTML'] = [
    'Adding correction for the HTML titles to not push charts most of the time and 1.1 subtitle lineheight',
    'Made HTML autodetect and create HTML instead of text',
    'Fixing an console error if axis are not there.',
    'Changing titles in place on context export',
    'Clarifying comments around this functionality',
    'Combining all title functions to avoid duplication',
    'Fixing the data-subtitle and data-chartTitle params.js descriptions'
];

bocAmchart4.version.features['DEV-9165-Try to fix Amcharts4 colors on print'] = [
    'Changed the way dark mode is done',
    'Fix for beforePrint error'
];

bocAmchart4.version.features['DEV-9087-Amcharts Analytics changes'] = [
    'Changed the Amcharts google analytics with new event names and parameters',
    'Use gtag instead of gtagEvent',
    'Move debug message to gtag',
    'Truncate debug by 40 for event and 100 for params',
    'Updated debug message',
    'Add new chart_series parameters to legend hide and show events',
    'Only calls gtag when analytics is enabled',
    'Fix bug in truncating debug message',
    'Modify debug for edge cases',
    'Cleanup code'
];
